import { buildQueryParams } from '../../common/misc';
import { fetcher } from '../../http/Fetcher';
import type {
    LegacyTransaction,
    PaymentTransactionsTableResponse,
    PaymentTransactionTableRequest,
    TransactionTableRequest,
    TransactionTableResponse,
} from '../types/Transactions';

export interface GetTransactionsResponse {
    next_page_token: string;
    result: LegacyTransaction[];
}

export interface GetTransactionsRequest {
    bankAccountId: string;
    query?: TransactionsQuery;
}

export interface TransactionsQuery {
    from_date?: string;
    to_date?: string;
    limit?: number;
    page_token?: string;
}

export const getTransactions = async ({
    bankAccountId,
    query,
}: GetTransactionsRequest): Promise<GetTransactionsResponse> => {
    return await fetcher({
        method: 'GET',
        endpoint: `/api/transactions/${bankAccountId}${buildQueryParams(
            query,
        )}`,
    });
};

export const getTransactionTable = async ({
    bankAccountId,
    ...query
}: TransactionTableRequest): Promise<TransactionTableResponse> => {
    return await fetcher({
        method: 'GET',
        endpoint: `/api/transactions/table/${bankAccountId}${buildQueryParams(
            query,
        )}`,
    });
};

export const getPaymentTransactionTable = async ({
    syncteraAccountId,
    ...query
}: PaymentTransactionTableRequest): Promise<PaymentTransactionsTableResponse> => {
    return await fetcher({
        method: 'GET',
        endpoint: `/api/transactions/payments-table/${syncteraAccountId}${buildQueryParams(
            query,
        )}`,
    });
};
